import type { Incident } from '@/lib/queries/rca/incidents';

import incidentIoLogo from '../../../integrations/-components/logos/incident-io.svg?url';
import pagerdutyLogo from '../../../integrations/-components/logos/pagerduty.svg?url';
import slackLogo from '../../../integrations/-components/logos/slack.svg?url';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getPrimaryIncidentData = (incident: Incident) => {
  if (incident.pagerDutyIncident) {
    return {
      incidentNumber: incident.pagerDutyIncident.incidentNumber,
      title: incident.pagerDutyIncident.title,
      summary: incident.pagerDutyIncident.summary,
      status: incident.pagerDutyIncident.status,
      priority: incident.pagerDutyIncident.priority,
      severity: undefined,
      startedAt: incident.pagerDutyIncident.startedAt,
      resolvedAt: incident.pagerDutyIncident.resolvedAt,
    };
  }

  // Note: incidentIoIncident not supported in current type structure

  if (incident.slackIncident) {
    // Generate simple incident number for Slack-only incidents
    const idNum = incident.id.replace('inc-', '');
    const incidentNumber = idNum === '12349' ? 1005 : parseInt(idNum, 10);

    return {
      incidentNumber,
      title:
        (incident.slackIncident.messageText !== ''
          ? incident.slackIncident.messageText
          : null) ?? `Slack Incident #${incidentNumber}`,
      summary:
        (incident.slackIncident.messageText !== ''
          ? incident.slackIncident.messageText
          : null) ?? 'Incident reported in Slack',
      status: incident.slackIncident.status,
      priority: undefined,
      severity: undefined,
      startedAt: incident.slackIncident.createdAt,
      resolvedAt: incident.slackIncident.updatedAt,
    };
  }

  return null;
};

export const getSourceIcon = (sourceType: string): string => {
  switch (sourceType) {
    case 'pagerduty':
      return pagerdutyLogo;
    case 'incident_io':
      return incidentIoLogo;
    case 'slack':
      return slackLogo;
    default:
      return pagerdutyLogo; // Default to PagerDuty logo if unknown source
  }
};

export const getSourceName = (sourceType: string): string => {
  switch (sourceType) {
    case 'pagerduty':
      return 'PagerDuty';
    case 'incident_io':
      return 'Incident.io';
    case 'slack':
      return 'Slack';
    default:
      return 'Unknown';
  }
};
